import { Box, Button, Container, Typography, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import Grid from '@mui/material/Unstable_Grid2';
//import NodeCanvasLogo from '../../../assets/NodeCanvasLogo.svg';
import NodeCanvasLogo from '../../../assets/hero2.png';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import heroBack from "../../../assets/hero-back.webp"


export const Hero = () => {


    return (
        <Container>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: -100,
                    pointerEvents: "none",
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${heroBack})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: .6,
                    }
                }}
            />
            <Grid container>
                <Grid xs={12} md={4}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <Box
                            component="img"
                            src={NodeCanvasLogo}
                            alt="logo"
                            loading="lazy"
                            sx={{
                                width: { xs: "200px", sm: "600px" },
                                height: { xs: "128px", sm: "384px" },
                                marginTop: { xs: "60px", sm: "150px" },
                                marginBottom: "12px",
                                zIndex: -20,
                            }}
                        />
                    </Box>
                </Grid>
                <Grid xs={12} md={8}>
                    <Typography
                        component="h1"
                        variant="h1"
                        sx={{
                            textAlign: "center",
                            fontWeight: "600",
                            marginTop: { xs: "60px", sm: "140px" },
                            fontSize: {
                                xs: "36px",
                                md: "42px",
                            },
                            lineHeight: "40px",
                            mb: 4,
                            zIndex: 21,
                        }}
                    >
                        Draw. Connect. Understand.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontWeight: "200",
                            fontSize: {
                                xs: "18px",
                                md: "28px",
                            },
                            lineHeight: "32px",
                            mb: 4,
                            zIndex: 26,
                        }}
                    >
                        Create vizualizations of your data in a few clicks.
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "50vh",
                            zIndex: 26,
                        }}
                    >
                        <Grid container direction="column" alignItems="center" justifyContent="center">
                            <Button
                                variant="outlined"
                                style={{
                                    borderRadius: 35,
                                    marginTop: 10,
                                    width: 280,
                                    height: 60,
                                    marginRight: 2,
                                    background: "#fca311",
                                    color: "#65372a",
                                    borderWidth: 0
                                }}
                                onClick={() => window.location.href = "/myprojects"}
                            >
                                <Typography>Start Project NOW</Typography>
                            </Button>
                            <Typography align="center" sx={{ marginTop: 2 }}>
                                <CheckIcon sx={{ fontSize: 16, paddingTop: "3px" }} color="disabled" />
                                Vizualize your data
                            </Typography>
                            <Typography align="center" sx={{ marginTop: 1 }}>
                                <CheckIcon sx={{ fontSize: 16, paddingTop: "3px" }} color="disabled" />
                                Share with public
                            </Typography>
                            <Typography align="center" sx={{ marginTop: 1 }}>
                                <CheckIcon sx={{ fontSize: 16, paddingTop: "3px" }} color="disabled" />
                                It's FREE
                                <Tooltip title="We're still in development, so some features may not be available." enterTouchDelay={0}>
                                    <InfoOutlinedIcon fontSize="inherit" sx={{marginLeft: 1, verticalAlign: 'middle', fontSize: 16, color: 'grey.600' }} />
                                </Tooltip>
                            </Typography>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};